





































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import RisikoJatuh from "@/components/pemeriksaan/assesmen/RisikoJatuh.vue";
import RiwayatAsesmenRisikoJatuh from "@/components/pemeriksaan/assesmen/RiwayatAsesmenRisikoJatuh.vue";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import { userModule } from "@/store/modules/user";
import { storeAssesmenRisikoJatuh } from "@/store/modules/asesmenrisikojatuh";
import DataAsesmenRisikoJatuh from "@/services/DataAsesmenRisikoJatuh";
import { appModule } from "@/store/modules/app";
import ErrorAlert from "@/utility/ErrorAlert";
import { storePerawat } from "@/store/modules/perawat";
import moment from "moment";

@Component({
  components: {
    RisikoJatuh,
    PerawatAutoComplete,
    TimeStamp,
    RiwayatAsesmenRisikoJatuh
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardAsesmenRisikoJatuh extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  maxDate = moment().format("YYYY-MM-DD");
  time = moment().format("HH:mm:ss");
  today = moment().format("YYYY-MM-DD");
  waktu = this.today + " " + this.time;

  risiko = null;
  waktu_periksa = this.today + " " + this.time;
  petugas_id = null;
  id = null;
  petugas = {
    id: null,
    nama: null
  };

  saving = false;
  deleting = false;

  get sendData() {
    return {
      id: this.id,
      risiko: this.risiko,
      petugas_id: this.petugas_id,
      waktu_periksa: this.waktu_periksa
    };
  }

  mounted() {
    this.waktu = this.todayTime;
  }

  setTime(val) {
    this.waktu_periksa = val;
  }

  get todayTime() {
    return this.today + " " + this.time;
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  get sessLogin() {
    return userModule.user;
  }

  get stateRisikoJatuh() {
    return storeAssesmenRisikoJatuh.asesmenRisikoJatuh;
  }

  get stateRiwayatRisikoJatuh() {
    return storeAssesmenRisikoJatuh.riwayatRisikoJatuh;
  }

  setPerawat(val) {
    this.petugas = val;
    this.petugas_id = val.id;
  }

  @Watch("stateRisikoJatuh")
  valAsesmenRisikoJatuh(val) {
    console.log("watch risjat", val);
    if (val) {
      this.id = val.id;
      this.risiko = val.risiko;
      this.petugas_id = val.petugas_id;
      this.waktu_periksa = val.waktu_periksa;
      this.petugas = val.petugas;
    }
  }

  save() {
    if (this.readOnly) return;
    const getparam = {
      unit_id: this.sessLogin.unit_id,
      reg: this.register
    };

    if (this.stateRisikoJatuh && this.stateRisikoJatuh["id"]) {
      if (!this.saving) {
        this.saving = true;

        DataAsesmenRisikoJatuh.editDataAsesmenRalan(
          this.sendData.id,
          this.sendData.petugas_id,
          this.sendData.risiko,
          this.sendData.waktu_periksa
        )
          .then(dt => {
            appModule.setLoading(false);
            if (dt["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
            } else {
              storeAssesmenRisikoJatuh.actAsesmenRisikoJatuh(getparam);
              storeAssesmenRisikoJatuh.actRiwayatRisikoJatuh(this.rm);
              appModule.NoticeDelay("Berhasil Update Asesmen Risiko Jatuh");
              if (this.risiko == 1) {
                appModule.sendErrorAlert(
                  "Pasien BERISIKO: Petugas asesmen melakukan edukasi ulang pada pasien agar meminimalkan mobilisasi dan jika mau mobilisasi harus didampingi oleh keluarga"
                );
              }
            }
          })
          .catch(err => {
            ErrorAlert.showErrorAlert(err);
          })
          .finally(() => (this.saving = false));
      } else {
        alert("Sedang ada proses menyimpan...");
      }
    } else {
      if (!this.saving) {
        this.saving = true;

        DataAsesmenRisikoJatuh.saveDataAsesmenRalan(
          this.register,
          this.rm,
          this.sessLogin.unit_id,
          this.sendData.petugas_id,
          this.sendData.risiko,
          this.sendData.waktu_periksa
        )
          .then(dt => {
            appModule.setLoading(false);
            if (dt["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
            } else {
              storeAssesmenRisikoJatuh.actAsesmenRisikoJatuh(getparam);
              storeAssesmenRisikoJatuh.actRiwayatRisikoJatuh(this.rm);
              appModule.NoticeDelay("Berhasil Simpan Asesmen Risiko Jatuh");
              if (this.risiko == "1") {
                appModule.sendErrorAlert(
                  "Pasien BERISIKO: Petugas asesmen melakukan edukasi ulang pada pasien agar meminimalkan mobilisasi dan jika mau mobilisasi harus didampingi oleh keluarga"
                );
              }
            }
          })
          .catch(err => {
            ErrorAlert.showErrorAlert(err);
          })
          .finally(() => (this.saving = false));
      } else {
        alert("Sedang ada proses menyimpan...");
      }
    }
  }

  clearInput() {
    this.id = null;
    this.risiko = null;
    this.petugas_id = null;
    this.waktu_periksa = this.todayTime;
    this.petugas = {
      id: null,
      nama: null
    };
  }

  deleteItem() {
    if (!this.deleting) {
      this.deleting = true;

      DataAsesmenRisikoJatuh.delete(this.sendData.id)
        .then(dt => {
          console.log("response delete", dt);
          appModule.setLoading(false);
          if (dt["status"] != 1) {
            appModule.sendErrorAlert("Gagal hapus data!");
          } else {
            storeAssesmenRisikoJatuh.actRiwayatRisikoJatuh(this.rm);
            appModule.NoticeDelay("Berhasil Hapus Asesmen Risiko Jatuh");
            this.clearInput();
          }
        })
        .catch(err => {
          ErrorAlert.showErrorAlert(err);
        })
        .finally(() => (this.deleting = false));
    } else {
      alert("Sedang ada proses menghapus...");
    }
  }
}
